import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./layout.css";
import OtpFieldComp from "../components/ui/otpFields/OtpFieldComp";
import OrderHeader from "../components/ui/childHeader/OrderHeader";
import { useGlobalContext } from "../context/GlobalContext";

const OrderLayout = () => {
  const { orderScreen, setOrderScreen } = useGlobalContext();

  useEffect(() => {
    setOrderScreen(false);
    // setOrderScreen(true);
  }, []);

  return (
    <div className="main-container">
      <div className="secondary-container">
        <div className="main-section">
          {!orderScreen && <OrderHeader />}
          {orderScreen && <OtpFieldComp />}
          {!orderScreen && <Outlet />}
        </div>
      </div>
    </div>
  );
};

export default OrderLayout;
